/** @module Apparel/ProductColorImageRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/NodeImage",
	"csi/html",
	"csi/model/image",
	"csi/xml",
], function(declare, NodeImage, html, {getDefaultImage, getImageSrc}, xml) {

	/**
	 * This renderer requires the ColorSpecification node to be in the cache, but not the image nodes
	 */

	return declare(NodeImage, {
		/**
		 * @override
		 * We don't have the image node here, but we do know the image URL
		 */
		setImageActionAttributes(ctx, h, domNode) {
			const node = this._getImageContainerNode(ctx, h);
			if (node) {
				html.setDataAttribute(domNode, html.DATA_IMG_URL, getDefaultImage(node));
			}
		},

		/**
		 * @override
		 * If image not available on ProductColor, then show the ColorSpecification image instead
		 */
		_getImageSrc(ctx, h, idImage) {
			const node = this._getImageContainerNode(ctx, h);
			return node ? getImageSrc(node, null, idImage) : null;
		},

		/**
		 * Return node containing image to display
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @return {C8Node}
		 */
		_getImageContainerNode(ctx, h) {
			const colorUrl = this._getStartingColorUrl(ctx, h);
			let colorNode = ctx.cache.get(colorUrl);

			while (colorNode) {
				const imageUrl = getDefaultImage(colorNode);

				if (xml.isValidURL(imageUrl)) {
					return colorNode;
				}

				// don't traverse nodes any further
				if (colorNode.$Type === "PrintDesignColor") {
					return null;
				}

				// look for color image on referenced color node - can traverse from
				// ProductColor -> ColorInPalette -> PrintDesignColor / ColorSpecification
				const nextNode = ctx.cache.get(colorNode.ColorSpecification);
				colorNode = (nextNode !== colorNode) ? nextNode : null;
			}

			return null;
		},

		/**
		 * Return referenced color from PartMaterial
		 * @param {Context} ctx 
		 * @param {Heading} h
		 * @return {cnl}
		 */
		_getStartingColorUrl(ctx, h) {
			// the Heading in this case has a path to the color, so color node is already in context
			return ctx.getNodeURL();
		}
	});
});